var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-element",class:_vm.classes,style:(_vm.getStyleOverride('image'))},[_c('ABImage',{attrs:{"alt":_vm.element.alt_text
        ? _vm.resolvedAltText ||
          (_vm.mode === 'editing' ? _vm.$t('imageElement.emptyValue') : '')
        : _vm.$t('imageElement.missingValue'),"src":_vm.imageSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }